<template>
  <div>
    <div
      v-if="dialogPlayground"
      class="playground-box"
    >
      <div class="playground-content">
        <div style="display:flex;">
          <div style="flex: 1"/>
          <div
            style="font-size: 20px; cursor:pointer; font-weight: bolder"
            @click="dialogPlayground = false"
          >
            X
          </div>
        </div>
        <div class="box-border">
          <div>
            <!-- Title -->
            <h3>Playground de Funcionalidades</h3>

            <div style="margin-bottom: 5px;">
              Client Key *
              <input
                v-model="clientKey"
                placeholder="Client Key *"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
            >
              idForm *
              <input
                v-model="idForm"
                placeholder="idForm *"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
            >
              idFormData
              <input
                v-model="idFormData"
                placeholder="idFormData"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
            >
              corPrimaria
              <input
                v-model="corPrimaria"
                placeholder="#0075EA"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
            >
              JSON
              <textarea
                style="width: 300px; height: 300px;"
                v-model="json"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
            >
              readOnly
              <input
                type="checkbox"
                v-model="readOnly"
              />
            </div>

            <div
              style="margin-bottom: 5px;"
              v-if="readOnly"
            >
              showOnly (-1 para exibir todos
              <input
                type="number"
                v-model="showOnly"
              />
            </div>

            <!-- Create -->
            <div
              style="margin-bottom: 5px;"
            >
              <button
                size="mini"
                @click="abrirForm"
              >
                Abrir Formulário
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="playground-btn"
      @click="abrirCfg"
    >
      cfg
    </div>

    <div
      v-if="renderForm"
      style="max-width: 1100px; margin: 0 auto; border: 1px solid #cccccc"
    >
      <router-view/>
    </div>
  </div>
</template>

<script>

import hexToRgba from 'hex-to-rgba'
import { mapState } from 'vuex'
// json.beneficiario.dadosDoContrato.numeroContrato
// language=JSON
const jsonBeneficiario = `{
  "beneficiario": {
    "bloqueio": {
      "bloqueado": false,
      "dataBloqueio": null,
      "motivo": null
    },
    "cartao": {
      "modeloCartao": "plano_basico",
      "numeroCartao": "00010002000001000",
      "validade": "2024-01-01",
      "via": 1,
      "numeroCns": "999999999999999",
      "apresentaCartaoVirtual": true,
      "nomeCartao": "martinazzi 47865306970",
      "nomeSocialCartao": "martinazzi 47865306970",
      "operadoraContratada": "XPTO",
      "convenioAnsContratada": "123123",
      "seed": "GEZDGMJSGMYTEMZRGIZQ====",
      "convenioAbrangenciaVerso": "São Paulo, Guarulhos, Santo André, São Bernardo,São Caetano, Diadema, Mauã, Ribeirão Pires"
    },
    "chaveUnica": "47865306970",
    "custom": {
      "tipo_sanguineo": "A+"
    },
    "dadosDoContrato": {
      "numeroContrato": "00100200300400500609"
    },
    "dadosDoPlano": {
      "beneficiario": true,
      "idPlano": "01",
      "descricao": "Plano Básico",
      "registroAns": "999.999/99-9",
      "segmentacao": "Ambulatorial + Hospitalar com obstetrícia",
      "acomodacao": "Individual",
      "tipoContratacao": "Coletivo por adesão",
      "regulamentacao": "Regulamentado",
      "abrangencia": "Estadual",
      "modalidadeCobranca": "Pós-pagamento",
      "padraoConforto": "Apartamento individual",
      "participativo": false,
      "dataInicioVigenciaPlano": "2021-01-01",
      "dataFinalCpt": "Não há",
      "matricula": "2320170425162943-0",
      "matriculaAntiga": null,
      "matriculaFuncionario": null,
      "tipoUsuario": {
        "codigo": "T",
        "descricao": "Titular"
      },
      "grauParentesco": {
        "codigo": "01",
        "descricao": "Titular"
      },
      "redeAtendimento": {
        "codigo": "01"
      },
      "carencias": [
        {
          "tipoServico": "Consultas",
          "carencia": "Isento"
        },
        {
          "tipoServico": "Exames simples",
          "carencia": "Isento"
        },
        {
          "tipoServico": "Exames especiais",
          "carencia": "28/02/2024"
        },
        {
          "tipoServico": "Terapias",
          "carencia": "Isento"
        },
        {
          "tipoServico": "Internações",
          "carencia": "28/02/2024"
        },
        {
          "tipoServico": "Obstetrícia",
          "carencia": "26/06/2024"
        }
      ]
    },
    "dadosPessoais": {
      "nome": "martinazzi 47865306970",
      "dataNascimento": "1990-01-01",
      "cpf": "47865306970",
      "sexo": {
        "codigo": "F",
        "descricao": "Feminino"
      },
      "contato": {
        "email": "rafael.martinazzi@mobilesaude.com.br",
        "telefoneCelular": "27981276906",
        "telefoneFixo": "2733778899"
      },
      "estadoCivil": {
        "codigo": "C",
        "descricao": "Casado"
      }
    },
    "integracao": {
      "chaveUnica": "47865306970",
      "cartao": "00010002000001000"
    }
  }
}`

export default {
  name: 'Playground',
  data () {
    return {
      clientKey: 'amparosaude',
      idForm: '6908ca4aec6015a10d0033ac',
      idFormData: '',
      json: jsonBeneficiario,
      corPrimaria: '#0075EA',
      showOnly: -1,
      readOnly: false,
      renderForm: false,
      dialogPlayground: true
    }
  },
  computed: {
    ...mapState({
      display: state => state.formJson.display,
      components: state => state.formJson.components
    })
  },
  created () {
    // Produção não tem acesso a essa pagina, redirecionar para notfound
    if (process.env.NODE_ENV === 'production') {
      return this.$router.push(`/404`)
    }
  },
  watch: {
    display (after) {
      switch (after) {
        case 'form':
        case 'wizard':
          if (this.$route.path.indexOf('playground') !== -1) {
            after += '-playground'
          }
          this.$router.replace({
            name: after,
            params: {
              components: this.components
            }
          })
          break
      }
    }
  },
  methods: {
    async abrirForm () {
      await this.fecharForm()

      let newJson = {}

      try {
        newJson = JSON.parse(this.json)
      } catch (ignored) {
        newJson = {}
      }

      let payload = {
        identifier: 'form-builder-1',
        clientKey: this.clientKey,
        idForm: this.idForm,
        idData: this.idFormData,
        json: this.json ? newJson : {},
        readOnly: this.readOnly,
        colors: {
          errors: '#ff4949',
          primary: this.corPrimaria
        }
      }

      await this.$store.dispatch('initialize', payload)
      // exemplo de json injetado pelo renderform
      /* const jsonData = {
        'beneficiario': {
          'dadosPessoais': {
            'nome': 'Everson Delmaschio dos Santos',
            'dataNascimento': '1994-08-05'
          },
          'dadosDoPlano': {
            'descricao': 'CASSI ESSENCIAL'
          },
          'dadosDoContrato': {
            'descricaoContrato': ''
          }
        }
      }

      await this.$store.dispatch('setJsonInjetado', jsonData) */

      if (this.readOnly) {
        await this.$store.dispatch('setShowOnly', this.showOnly)
      }
      this.setVueStyle(payload.colors)

      this.dialogPlayground = false
      this.renderForm = true
    },
    async fecharForm () {
      try {
        await this.$router.replace(`/playground/`)
      } catch (ignored) {}

      this.renderForm = false
    },
    setVueStyle (colors) {
      if (colors.primary) {
        const color = colors.primary
        this.$style['brand-primary'] = color
        this.$style['input-bg'] = hexToRgba(color, '0.08')
        this.$style['input-focus-bg'] = hexToRgba(color, '0.16')
        this.$style['input-file-read-only-card-bg'] = hexToRgba(color, '0.05')
        this.$style['input-border'] = hexToRgba(color, '0.08')
        this.$style['input-border-focus'] = hexToRgba(color, '0.08')
        this.$style['state-focus-border-bottom'] = hexToRgba(color, '0.08')
        this.$style['state-focus-placeholder'] = hexToRgba(color, '0.3')
      }
      if (colors.errors) {
        const color = colors.errors
        this.$style['brand-danger'] = color
        this.$style['state-danger-text'] = color
        this.$style['state-danger-bg'] = hexToRgba(color, '0.08')
        this.$style['state-danger-focus-bg'] = hexToRgba(color, '0.16')
        this.$style['state-danger-border'] = hexToRgba(color, '0.08')
        this.$style['state-danger-addon-text'] = hexToRgba(color, '0.4')
        this.$style['state-danger-placeholder'] = hexToRgba(color, '0.3')
      }
      if (colors.alert) {
        const color = colors.alert
        this.$style['brand-warning'] = color
        this.$style['state-warning-text'] = color
        this.$style['state-warning-bg'] = hexToRgba(color, '0.08')
        this.$style['state-warning-focus-bg'] = hexToRgba(color, '0.16')
        this.$style['state-warning-border'] = hexToRgba(color, '0.08')
        this.$style['state-warning-addon-text'] = hexToRgba(color, '0.4')
        this.$style['state-warning-placeholder'] = hexToRgba(color, '0.3')
      }
    },
    async abrirCfg () {
      // const formData = await this.for
      // this.json = JSON.stringify(formData)
      this.dialogPlayground = true
    }
  }
}
</script>

<style scoped>
.box-border {
  border: 1px solid black;
  margin-bottom: 20px;
  padding: 20px;
}

.playground-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 50px;
  border: 1px solid #000000;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 23px;
  color: red;
  z-index: 1999;
}

.playground-btn :hover {
  opacity: 1;
}

.playground-box {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.2);
}

.playground-content {
  min-width: 600px;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #000000;
}
</style>
